<template>
  <div class="bg-white rounded shadow-lg">
    <vs-row style="height: 79vh" class="relative">
      <div v-click-outside="closeSidebar" ref="sidebar" class="lg:block lg:w-4/12 h-full sidebar" :class="[{'active': vars.sidebarOpen}]">
        <div class="flex flex-col pt-3" style="height: 100%">
          <div class="flex flex-row justify-between items-baseline px-3">
            <h4 class="mt-3 mb-5">Chats</h4>
            <button @click="vars.popup=true" class="button-hover cursor-pointer">
              <span class="icon">+</span>
              <span class="text">Create Chat Room</span>
            </button>
          </div>
          <div class="px-3">
            <div class="relative w-full">
              <i class="vs-icon notranslate icon-scale material-icons null absolute z-50" style="top: 12px; right: 10px">search</i>
              <vs-input class="w-full" placeholder="Search user..." v-model="models.search" @input="handleSearchMessage"/>
            </div>
          </div>

          <div class="flex flex-row justify-around my-3 px-3">
            <div 
              class="rounded-sm w-full relative" 
              v-for="type in masters.chat_types"
              :key="type.value">
              <vs-button
                :class="{'text-primary': type.value !== models.chat_type}"
                :color="type.value === models.chat_type ? 'primary' : '#fff'" 
                type="filled" 
                @click="models.chat_type = type.value"
                >{{type.text}}
              </vs-button>
              <!-- <span class="absolute bg-danger h-6 w-6 text-white text-center z-10 rounded-full text-xs" style="padding-top: 3px; top: -10px; right: -5px">5</span> -->
            </div>
          </div>

          <div v-if="channels.length" class="overflow-y-auto overflow-x-hidden h-full" id="sidebarChat">
            <div :class="{'bg-grey-light': activeChat && chat.name === activeChat.channelName}" @click="getDetailMessage(chat)" v-for="(chat, index) in channels" :key="index" class="w-full border-b border-solid border-0 border-grey-light py-2 flex items-center cursor-pointer pr-4 pl-3">
              <img v-if="activeTypeChat !== 'personal'" class="w-12 h-12 object-cover rounded-full" :src="getUrlOfFile(chat.avatar)" alt="img-user">
              <img v-else class="w-12 h-12 rounded-full" src="/img/chat-double.png" alt="img-user" style="object-fit: scale-down">
              <div class="pl-3 flex w-full flex-col relative">
                <div class="flex justify-between">
                  <h5>{{truncate(chat.fullName, 15)}}</h5>
                  <p class="text-sm">{{moment(chat.updatedAt).format('HH:mm')}}</p>
                </div>
                <p v-if="chat.lastMessage" class="whitespace-no-wrap text-sm">{{truncate(chat.lastMessage, 20)}}</p>
                <span v-if="chat.unread > 0" class="absolute bg-primary text-sm text-white w-5 h-5 text-center rounded-full" style="right: 0; bottom: 0">{{chat.unread}}</span>
              </div>
            </div>
            <button @click="loadMoreChannels" v-if="channels.length < models.countChannels" class="bg-transparent block m-auto border-0 py-2 cursor-pointer my-2">Load More</button>
          </div>
          <div v-else class="flex justify-center items-center flex-auto">
            <p class="text-center">No chats found</p>
          </div>
        </div>

        <!-- Popup create new chat -->
        <vs-popup title="Create new chat room" :active.sync="vars.popup">
          <ul class="flex flex-row w-1/2 md:w-1/3 justify-between mb-5">
            <li>
              <vs-radio v-model="models.type" vs-name="type" vs-value="personal">Personal</vs-radio>
            </li>
            <li>
              <vs-radio v-model="models.type" vs-name="type" vs-value="group">Group</vs-radio>
            </li>
          </ul>

          <vs-row v-if="models.type === 'group'">
            <div class="w-full md:w-4/12 mb-5 md:mb-0 md:pr-2">
              <img :src="getUrlOfFile(models.avatar, true)" alt="image-profile" class="w-3/4 md:w-full block m-auto">
              <vs-button color="primary" type="border" icon="upload_file" class="w-full mt-3" @click="$refs.file_upload.click()">
                <span class="text-xs">Upload Photo</span>
              </vs-button>
              <input ref="file_upload" type="file" accept="image/png, image/gif, image/jpeg, image/jpg"
                v-on:change="AddPhoto" hidden />
            </div>
            <div class="w-full md:w-8/12 md:px-3">
              <div class="w-full mb-2 md:mb-5">
                <vs-input 
                    autocomplete="off"
                    label="Subject Chat" 
                    type="text"
                    v-model="models.subject" 
                    class="w-full"/>
              </div>

              <div class="w-full mb-2 md:mb-5">
                <vs-textarea
                    label="Description"
                    type="text"
                    v-model="models.description" 
                    rows="5"
                    class="w-full">
                </vs-textarea>
              </div>
            </div>
            <vs-checkbox v-model="vars.chooseAll">Choose All Participants</vs-checkbox>
          </vs-row>


          <div class="md:mt-4">
            <label for="participant" class="text-sm pl-1 text-muted">Participant</label>
            <v-select 
              :disabled="chooseAll"
              :class="{'bg-grey': chooseAll}"
              :filterable="false" 
              @search="debounceSearch"
              placeholder="Choose Participant" 
              label="name"
              :multiple="models.type === 'group'"
              :options="masters.participants"
              v-model="participant"
            >
              <template v-if="masters.participants.length >= 10 && (masters.participants.length < models.totalParticipants)" #list-footer>
                <button @click="loadMoreCustomers" class="flex py-2" style="opacity: 0.8; margin: auto; background: transparent; border: none">
                 {{ onLoadMore ? 'Please wait...' : 'Click to load more' }}
                </button>
              </template>
            </v-select>
          </div>

          <div class="w-1/2 flex flex-row ml-auto mt-10">
            <div class="w-1/2 pr-1">
              <vs-button @click="vars.popup = false" color="rgb(172,172,172)" type="border" class="w-full px-0">Cancel</vs-button>
            </div>
            <div class="w-1/2 pl-1">
              <vs-button :disabled="!disabledSave" @click="createChannel" class="w-full px-0">Save</vs-button>
            </div>
          </div>
        </vs-popup>
      </div>

      <div v-if="activeChat" ref="roomchat" class="flex flex-col justify-between w-full lg:w-8/12 h-full relative">
        <div v-if="vars.sidebarOpen" id="overlay"></div>
        <div class="border rounded-lg border-solid border-grey-light py-2 flex items-center cursor-pointerd justify-between md:px-2 pr-4">
          <div class="flex flex-row items-center">
            <vs-icon @click="vars.sidebarOpen = true" class="ml-5 block lg:hidden" icon="menu" size="2rem"></vs-icon>
            <img v-if="activeTypeChat !== 'personal'" class="ml-5 w-12 h-12 object-cover rounded-full" :src="getUrlOfFile(activeChat.avatar)" alt="img-user">
            <img v-else class="ml-5 w-12 h-12 rounded-full" src="/img/chat-double.png" alt="img-user" style="object-fit: scale-down">

            <h5 class="pl-2">{{truncate(activeChat.fullName, 30)}}</h5>
          </div>

          <vs-dropdown vs-custom-content vs-trigger-click v-if="models.chat_type !== 'personal'">
            <button class="bg-transparent border-none outline-none cursor-pointer">
              <vs-icon icon="more_vertical" size="small"></vs-icon>
            </button>

            <vs-dropdown-menu class="vx-navbar-dropdown">
              <ul style="min-width: 11rem">
                <li
                  v-if="activeTypeChat === 'group'"
                  @click="vars.popupParticipants = true"
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                  <span class="block m-auto">Kick Participants</span>
                </li>
                <li
                  v-if="activeTypeChat === 'group'"
                  @click="openPopupChangeAva"
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                  <span class="block m-auto">Change avatar</span>
                </li>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="deleteChannel(activeChat.channelId)">
                  <span class="block m-auto text-danger">Delete {{activeTypeChat === 'group' ? 'group' : 'chat'}}</span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <div id="roomChat" class="message p-5 overflow-y-auto h-full" style="background: #d0d0d0" v-html="renderMessage(activeChat.messages)">
        </div>
        <form @submit.prevent="sendMessage" v-if="models.chat_type !== 'personal'" class="p-5 border-l border-solid border-0 border-grey-light rounded-lg">
          <div class="relative w-full">
            <vs-button @click="sendMessage" color="primary" type="filled" icon="send" class="absolute z-50 cursor-pointer p-0" style="top: 0; right: 0"></vs-button>
            <vs-input v-model="models.message" class="w-full" placeholder="Type something" button="submit"/>
          </div>
        </form>
      </div>
      <div v-else ref="roomchat" class="flex flex-col justify-between w-full lg:w-8/12 h-full relative border border-solid border-grey-light" style="background: #f5f5f5">
        <div class="flex justify-center items-center h-full flex-col">
          <img src="logo.png" class="h-48 mb-3" alt="logo">
          <vs-button @click="vars.sidebarOpen = true" class="lg:hidden">Start Conversation</vs-button>
        </div>
      </div>

      <vs-popup title="Change avatar" :active.sync="vars.popupAvatar">
        <vs-row>
          <div class="w-full md:w-4/12 mb-5 md:mb-0 md:pr-2 m-auto">
            <img :src="getUrlOfFile(models.avatar, true)" alt="image-profile" class="w-3/4 md:w-full block m-auto">
            <vs-button color="primary" type="border" icon="upload_file" class="w-full mt-3" @click="$refs.file_upload.click()">
              <span class="text-xs">Upload Photo</span>
            </vs-button>
            <input ref="file_upload" type="file" accept="image/png, image/gif, image/jpeg, image/jpg"
              v-on:change="AddPhoto" hidden />
          </div>
        </vs-row>

        <div class="w-full flex flex-row ml-auto mt-10">
          <div class="w-1/2 pr-1">
            <vs-button @click="vars.popupAvatar = false" color="rgb(172,172,172)" type="border" class="w-full px-0">Cancel</vs-button>
          </div>
          <div class="w-1/2 pl-1">
            <vs-button @click="updateChannel" class="w-full px-0">Save</vs-button>
          </div>
        </div>
      </vs-popup>
      <vs-popup title="Kick Participants" :active.sync="vars.popupParticipants">
        <div v-if="activeChat" class="w-full flex md:flex-row flex-col">
          <div class="w-full md:w-1/2">
            <h5>List Participants</h5>
            <div id="participants" class="md:border-grey md:border-solid md:border-0 md:border-r mt-4 md:pr-3" style="min-height: 10rem; max-height: 17rem; overflow: auto">
              <ul>
                <li v-for="(user, idx) in activeChat.temp_participants" :key="idx" class="relative border border-solid border-grey-light p-3 pl-4" style="border-radius: 15px">
                  <span class="text-base font-semibold">{{user.name}}</span>
                  <vs-button @click="removeParticipant(user)" class="absolute" style="right: 5px; top: 8px" size="small" radius color="danger" type="filled" icon="close"></vs-button>
                </li>
              </ul>
            </div>
          </div>
          <div class="w-full md:w-1/2 md:pl-3 mt-5 md:mt-0">
            <h5 >Deleted Participants</h5>
            <div id="participants" class="mt-4" style="min-height: 10rem; max-height: 17rem; overflow: auto">
              <ul>
                <li v-for="(user, idx) in tempKickParticipants" :key="idx" class="relative border border-solid border-grey-light p-3 pl-4" style="border-radius: 15px">
                  <span class="text-base font-semibold">{{user.name}}</span>
                  <vs-button @click="undoParticipant(user)" class="absolute" style="right: 5px; top: 8px" size="small" radius color="warning" type="filled" icon="undo"></vs-button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="w-full flex flex-row ml-auto mt-10">
          <div class="w-1/2 pr-1">
            <vs-button @click="vars.popupParticipants = false" color="rgb(172,172,172)" type="border" class="w-full px-0">Cancel</vs-button>
          </div>
          <div class="w-1/2 pl-1">
            <vs-button :disabled="tempKickParticipants.length < 1" @click="kickParticipants" class="w-full px-0">Save</vs-button>
          </div>
        </div>
      </vs-popup>
    </vs-row>
	</div>
</template>

<script>
import api from '@/utils/api.js'
import {mapState} from 'vuex'
import ClickOutside from 'vue-click-outside'
import {
		getUrlOfFile,
    truncate,
    uploadFile
	} from '@/utils/helpers.js';
  import moment from 'moment'
export default {
  data() {
    return{
      moment,
      truncate,
      vars: {
        sidebarOpen: false,
        popup:false,
        popupAvatar: false,
        popupParticipants: false,
        chooseAll: false
      },
      models: {
        chat_type: 'admin',
        channels: [],
        countChannels: 0,
        currentPage: 1,

        type: 'personal',
        totalParticipants: 0,

        // form field
        participant: null,
        participants: [],
        description: '',
        avatar: null,
        subject: '',


        // form message
        message: '',

        // form search
        search: '',
        
        // kick participants list
        accountIds: []
      },
      masters: {
        chat_types: [
            {
              text: 'Admin',
              value: 'admin'
            },
            {
              text: 'User',
              value: 'personal'
            },
            {
              text: 'Group',
              value: 'group'
            },
        ],
        participants: []
      },
			getUrlOfFile,
      query: '',
      onLoadMore: false,
      initialPagePart: 1
    }
  },
  computed: {
    ...mapState(['AppActiveUser', 'activeChat', 'activeTypeChat', 'channels']),
    participant: {
      get() {
        if(this.models.type === 'personal') {
          return this.models.participant
        }
        return this.models.participants
      },
      set(val) {
        if(this.models.type === 'personal') {
          return this.models.participant = val
        }
        this.models.participants = [...val]
      }
    },
    chooseAll() {
      return this.vars.chooseAll
    },
    type() {
      return this.models.type
    },
    chat_type() {
      return this.models.chat_type
    },
    popupAvatar() {
      return this.vars.popupAvatar
    },
    popupParticipants() {
      return this.vars.popupParticipants
    },
    tempKickParticipants() {
      return this.models.accountIds
    },
    
    disabledSave() {
      if(this.type === 'personal') {
        return this.models.participant
      } else if (this.type === 'group') {
        return this.chooseAll || this.models.participants.length
      }
    }
  },
  mounted() {
    this.getParticipants()
    if(!this.channels.length) {
      this.getChannels()
    }
    this.models.chat_type = this.activeTypeChat

    this.$watch('activeChat', () => {
      const container = this.$el.querySelector("#roomChat");
      if(container) {
        container.scrollTop = container.scrollHeight;
      }
    })
    this.$watch('activeTypeChat', () => {
      this.$store.commit('UPDATE_ACTIVE_CHAT', null)
    })
  },
  watch: {
    chat_type() {
      this.$store.commit('UPDATE_ACTIVE_TYPE_CHAT', this.chat_type) 
      this.models.currentPage = 1
      this.$store.commit('UPDATE_LIST_CHANNELS', [])
      this.getChannels()
    },

    popupAvatar() {
      if(this.popupAvatar === false) {
        this.models.avatar = null
      }
    },
    popupParticipants() {
      if(this.popupParticipants === false) {
        this.models.accountIds = []
        if(this.activeChat) {
          const payload = {
            ...this.activeChat,
            temp_participants: [...this.activeChat.participants]
          }
          this.$store.commit('UPDATE_ACTIVE_CHAT', payload)
        }
      }
    },

    type() {
      this.vars.chooseAll = false
    },
    chooseAll () {
      if(this.chooseAll && this.models.participants.length) {
        this.models.participants = []
      }
    }
  },
  methods: {
    closeSidebar() {
      this.vars.sidebarOpen = false
    },

    openPopupChangeAva() {
      this.vars.popupAvatar = true
      this.models.avatar = this.activeChat.avatar
    },

    AddPhoto(event) {
      let fileSizeLimit = 1024 * 1024 * 2; // limit 2 MB
      if(event.target.files[0].size < fileSizeLimit) {
        this.models.avatar = event.target.files[0];

        event.target.value = null
      } else {
        this.$showToast('Failed', `Max file size is 2 MB`, 'danger')
      }
    },

    getParticipants(loading, page = 1) {
      return this.$axios.get(`${api.chat}/users?limit=10&page=${page}&search=${this.query}`)
        .then(res => {
          this.models.totalParticipants = res.data.data.count
          res.data.data.rows.map(customer => {
            this.masters.participants.push(customer)
          })
        })
    },

    loadMoreChannels() {
      this.models.currentPage++
      this.getChannels()
    },

    getChannels(isSearch) {
      const page = isSearch === 'search' ? '1' : this.models.currentPage
      const search = this.models.search !== '' ? `&search=${this.models.search}` : ''
      this.$axios.get(`${api.channels}/${this.chat_type}?sortBy=updatedAt.DESC&page=${page}&limit=10${search}`)
        .then(res => {
          let channels = isSearch === 'search' ? [...res.data.data.rows] : [...this.channels, ...res.data.data.rows]
          this.$store.commit('UPDATE_LIST_CHANNELS', channels)

          setTimeout(() => {
            this.$store.commit('UPDATE_DIFFERENT_TYPE_CHAT', false)
          }, 1000);

          this.models.countChannels = res.data.data.count
        })
    },

    deleteChannel(id) {
      let type = this.activeTypeChat === 'group' ? 'group' : 'chat'
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: `Are you sure want to delete this ${type}?`,
        acceptText: "Yes",
        cancelText: "No",
        accept: () => {
          if(id) {
            this.$axios.delete(`/channels/${id}`)
              .then(() => {
                let channels = this.channels.filter(channel => channel.id !== id)
                this.$store.commit('UPDATE_LIST_CHANNELS', channels)
                this.$store.commit('UPDATE_ACTIVE_CHAT', null)

								this.$showToast('Success', `Success delete ${type}`,)

              })
          }
        }
      })
    },

    async updateChannel() {
      if(this.activeChat && this.models.avatar) {
				const avatar = typeof this.models.avatar === 'string' ? this.models.avatar : await uploadFile(this.models.avatar)

        this.vars.popupAvatar = false
        this.$axios.put(`${api.channels}/${this.activeChat.channelId}`, {avatar})
          .then(() => {
            const channels = JSON.parse(JSON.stringify(this.channels))
            let channelIdx = channels.findIndex(channel => channel.name === this.activeChat.channelName)
            channels[channelIdx].avatar = avatar

            const activeChat = {
              ...this.activeChat,
              avatar
            }

            this.$store.commit('UPDATE_ACTIVE_CHAT', activeChat)
            this.$store.commit('UPDATE_LIST_CHANNELS', channels)

						this.$showToast('Success', `Success update avatar!`)

          })
      }
    },

    async createChannel() {
      if(this.models.type === 'personal') {
        this.$axios.post(`${api.chat}/init-room/personal`, { to: this.models.participant.accountId })
          .then(() => {
						this.$showToast('Success', `Success create chat room!`)
            this.vars.popup = false
            if(this.models.chat_type !== 'admin') {
              this.models.chat_type = 'admin'
              
              this.$store.commit('UPDATE_DIFFERENT_TYPE_CHAT', true)
            }
          }).then(() => {
            this.models.participant = null
          })
      } else {
				const avatar = typeof this.models.avatar === 'string' ? this.models.avatar : await uploadFile(this.models.avatar)
        const accountIds = this.chooseAll ? null : this.models.participants.map(participant => participant.accountId)
        this.$axios.post(`${api.chat}/init-room`, {
          avatar,
          subject: this.models.subject,
          description: this.models.description,
          accountIds
        })
          .then(() => {
						this.$showToast('Success', `Success create group chat room!`)
            this.vars.popup = false
            if(this.models.chat_type !== 'group') {
              this.models.chat_type = 'group'

              this.$store.commit('UPDATE_DIFFERENT_TYPE_CHAT', true)
            }

          }).then(() => {
            this.models.participants = []
          })
      }
    },

    sendMessage() {
      if(this.models.message !== '') {
        this.$axios.post('/chat/send', {
          channelName: this.activeChat.channelName,
          message: this.models.message
        }).then((res) => {
          const activeChat = {
            ...this.activeChat,
            messages: [
              ...this.activeChat.messages,
              res.data.data
            ]
          }
          this.$store.commit('UPDATE_ACTIVE_CHAT', activeChat)
          this.models.message = ''
        }).catch(() => {
          this.models.message = ''
        })
      }
    },

    renderMessage(messages) {
      let msg = ''
      messages.map(message => {
        const isPersonal = this.activeTypeChat !== 'admin' ? `<strong>${truncate(message.name, 20)}</strong>`:``

        if(message.accountId === this.AppActiveUser.admin.accountId) {
          msg += `
          <div class="max-w-sm relative shadow p-2 pb-6 px-3 rounded-lg bg-primary mb-2 ml-auto text-white text-right" style="width: fit-content; min-width: 50px">
            <p>${message.message}</p>
            <small class="text-white absolute" style="right: 5px; bottom: 0">${moment(message.timestamp).format('HH:mm')}</small>
          </div>
          `
        } else {
          msg += `
          <div class="max-w-sm relative shadow p-2 pb-6 px-3 rounded-lg bg-white mb-2" style="width: fit-content; min-width: 50px">
            ${isPersonal}
            <p>${message.message}</p>
            <small class="text-grey absolute" style="right: 5px; bottom: 0">${moment(message.timestamp).format('HH:mm')}</small>
          </div>
          `
        }
      })

      return msg
    },

    getDetailMessage(chat) {
      if(chat.unread) {
        const dplctChannels = JSON.parse(JSON.stringify(this.channels))
        let channelIdx = dplctChannels.findIndex(channel => channel.name === chat.name)
        let channels = dplctChannels

        channels[channelIdx].unread = 0
        this.$store.commit('UPDATE_LIST_CHANNELS', channels)
      }
      const detailMessage = this.$axios.get(`${api.channels}/${chat.id}/messages`)
      const detailChannel = this.$axios.get(`${api.channels}/${chat.id}`)
      Promise.all([detailMessage, detailChannel])
        .then(res => {
          const payload = {
            channelId: chat.id,
            fullName: chat.fullName,
            avatar: chat.avatar,
            channelName: chat.name,
            messages: res[0].data.data,
            participants: res[1].data.data.participants,
            temp_participants: res[1].data.data.participants,
          }
          this.$store.commit('UPDATE_ACTIVE_CHAT', payload)
          this.vars.sidebarOpen = false
        })
    },

    removeParticipant(user) {
      this.models.accountIds.push(user)

      const payload = {
        ...this.activeChat,
        temp_participants: this.activeChat.temp_participants.filter(participant => participant.accountId !== user.accountId)
      }
      this.$store.commit('UPDATE_ACTIVE_CHAT', payload)

    },

    undoParticipant(user) {
      this.models.accountIds = this.models.accountIds.filter(participant => participant.accountId !== user.accountId)
      const payload = {
        ...this.activeChat,
        temp_participants: [user, ...this.activeChat.temp_participants]
      }
      this.$store.commit('UPDATE_ACTIVE_CHAT', payload)
    },

    kickParticipants() {
      if(this.tempKickParticipants.length > 0 && this.activeChat) {
        const deletedIdParticipants = this.models.accountIds.map(participant => participant.accountId)
        this.$axios.post(`${api.channels}/${this.activeChat.channelId}/kick`, {accountIds: deletedIdParticipants})
          .then(() => {
            const payload = {
              ...this.activeChat,
              participants: [...this.activeChat.temp_participants]
            }
            this.$store.commit('UPDATE_ACTIVE_CHAT', payload)
						this.$showToast('Success', `Success kick participant!`)
            
            this.vars.popupParticipants = false
          })
      }
    },

    loadMoreCustomers(){
      this.onLoadMore = true
      this.initialPagePart++
      this.getParticipants(null, this.initialPagePart)
        .then(() => {
          this.onLoadMore = false
        })
    },

    debounceSearch(query, loading){
      clearTimeout(this.debounce)
      this.query = query
      this.initialPagePart = 1
      this.debounce = setTimeout(() => {
        this.masters.participants = []
        this.getParticipants(loading, this.initialPagePart)
      }, 500)
    },

    handleSearchMessage() {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        // isSearch
        this.getChannels('search')
      }, 300)
    },
  },
   // do not forget this section
  directives: {
    ClickOutside
  }
}
</script>

<style scoped>
.button-hover {
  border: none;
  background-color: #7093D8;
  color: white;
  text-decoration: none;
  border-radius: 60px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  overflow:hidden;
  width: auto;
  max-width: 32px; /** I'm animating max-width because width needs to be auto, and auto can't be animated **/
  -webkit-transition: max-width 0.5s;
  transition: max-width 0.5s;
}

.button-hover:hover {
  max-width: 300px;
}

.icon {
  font-family: "Font Awesome 5 Free";
  font-size: 20px;
  font-weight: bold;
  margin-right: 5px;
  padding: 0px 10px;
  display: flex;
  align-items: center;
}

.text {
  white-space: nowrap;
  padding-right: 15px;
}
#sidebarChat::-webkit-scrollbar, #roomChat::-webkit-scrollbar , #participants::-webkit-scrollbar{
    width: 3px !important;
    height: 3px !important;
}
#sidebarChat::-webkit-scrollbar-thumb, #roomChat::-webkit-scrollbar-thumb, #participants::-webkit-scrollbar-thumb{
    background-color: lightgray;
}
#overlay {
  position: absolute; /* Sit on top of the page content */
  display: block; /* Hidden by default */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.1); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}

/* .sidebar{
  position: absolute;
  z-index: 30;
  background: white;
  left: -300px;
  transition: .3s ease-in-out;
} */
@media (max-width: 991.98px) {
  .sidebar{
    position: absolute;
    z-index: 30;
    background: white;
    left: -400px;
    transition: .3s ease-in-out;
  }

  .sidebar.active {
    left: 0
  }
}

</style>